import { Component, OnInit, inject } from "@angular/core";
import { DataAccessService } from "../core/services/data-access.service";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import Swal from "sweetalert2";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "attachment-dialog",
    templateUrl: "attachment-dialog.html",
    styleUrls: ["./claim_edit.scss"],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatButton, MatIcon, MatDialogActions]
})
export class AttachmentDialog implements OnInit {
  dialogRef = inject<MatDialogRef<AttachmentDialog>>(MatDialogRef);
  data = inject<object>(MAT_DIALOG_DATA);
  private dataAccess = inject(DataAccessService);

  id: number;
  action: string;
  customer_attachments: any;
  supplier_attachments: any;

  constructor() {
    const data = this.data;

    this.id = (data as any).id;
    this.action = (data as any).action;
  }

  ngOnInit() {
    if (this.action == "show") {
      this.dataAccess
        .getJSONPost(
          "get_claim_attachments",
          [],
          [
            { k: "p_claim_id", v: this.id },
            { k: "p_category", v: "supplier" },
          ]
        )
        .then((data) => {
          this.supplier_attachments = Array.isArray(data) ? data : [];
        });

      this.dataAccess
        .getJSONPost(
          "get_claim_attachments",
          [],
          [
            { k: "p_claim_id", v: this.id },
            { k: "p_category", v: "customer" },
          ]
        )
        .then((data) => {
          this.customer_attachments = Array.isArray(data) ? data : [];
        });
    }
  }

  deleteFile() {
    this.dataAccess
      .getJSONPost("remove_attachment", [], [{ k: "p_id", v: this.id }])
      .then((data) => {
        if (data.res != 0) {
          Swal.fire("Error!", data.msg, "error");
        } else {
          Swal.fire({
            icon: "success",
            title: "Attachment deleted!",
            showConfirmButton: false,
            timer: 1500,
            willClose: () => {
              this.dialogRef.close();
            },
          });
        }
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
